import content from '../content'

export default {
  computed: {
    c() {
      return content.data
    }
  }
}
